module.exports = __webpack_public_path__ + "static/pic7-5d9c56d31fe5ed8170d1679836640ffd.png";